export default __webpack_public_path__ + "static/media/longscreens-MV-DTC.b33aa789.jpg";